import(/* webpackMode: "eager" */ "/app/src/app/wedding-suppliers/[[...slug]]/layout.tsx");
